(function($){
    'use strict';

}(jQuery));